import request from '@/plugins/axios'
// 客户档案查询
export function queryCustomerProfileApi(data) {
    return request({
        url: '/basicCustomers/v1.0.0/pageJson',
        method: 'post',
        data
    })
}
// 客户档案详情
export function queryCustomerProfileDetailsApi(data) {
    return request({
        url: '/basicCustomers/v1.0.0/detail',
        method: 'post',
        data
    })
}
// 客户档案新增
export function queryCustomerProfileAddApi(data) {
    return request({
        url: '/basicCustomers/v1.0.0/add',
        method: 'post',
        data
    })
}
// 客户档案编辑
export function queryCustomerProfileEditApi(data) {
    return request({
        url: '/basicCustomers/v1.0.0/update',
        method: 'post',
        data
    })
}
// 客户档案删除
export function queryCustomerProfileDeleteApi(data) {
    return request({
        url: '/basicCustomers/v1.0.0/delete',
        method: 'post',
        data
    })
}
// 我方主体查询
export function queryOurSubInfoApi(data) {
    return request({
        url: '/basicOwners/v1.0.0/pageJson',
        method: 'post',
        data
    })
}
// 我方主体详情
export function queryOurSubInfoDetailsApi(data) {
    return request({
        url: '/basicOwners/v1.0.0/detail',
        method: 'post',
        data
    })
}
// 我方主体新增
export function queryOurSubInfoAddApi(data) {
    return request({
        url: '/basicOwners/v1.0.0/add',
        method: 'post',
        data
    })
}
// 我方主体编辑
export function queryOurSubInfoEditApi(data) {
    return request({
        url: '/basicOwners/v1.0.0/update',
        method: 'post',
        data
    })
}
// 我方主体删除
export function queryOurSubInfoDeleteApi(data) {
    return request({
        url: '/basicOwners/v1.0.0/delete',
        method: 'post',
        data
    })
}
// 供应商查询
export function querySupplierInfoApi(data) {
    return request({
        url: '/basicSuppliers/v1.0.0/pageJson',
        method: 'post',
        data
    })
}
// 供应商详情
export function querySupplierInfoDetailsApi(data) {
    return request({
        url: '/basicSuppliers/v1.0.0/detail',
        method: 'post',
        data
    })
}
// 供应商新增
export function querySupplierInfoAddApi(data) {
    return request({
        url: '/basicSuppliers/v1.0.0/add',
        method: 'post',
        data
    })
}
// 供应商修改
export function querySupplierInfoEditApi(data) {
    return request({
        url: '/basicSuppliers/v1.0.0/update',
        method: 'post',
        data
    })
}
// 供应商删除
export function querySupplierInfoDeteleApi(data) {
    return request({
        url: '/basicSuppliers/v1.0.0/delete',
        method: 'post',
        data
    })
}
// 供应商列表 
export function queryBasicSuppliersListApi(data) {
    return request({
        url: '/basicSuppliers/v1.0.0/listJson',
        method: 'post',
        data
    })
}
// 客户列表  
export function querySupplierInfoListApi(data) {
    return request({
        url: '/basicCustomers/v1.0.0/listJson',
        method: 'post',
        data
    })
}
// 负责单位列表
export function queryBasicOwnersListApi(data) {
    return request({
        url: '/basicOwners/v1.0.0/listJson',
        method: 'post',
        data
    })
}
// 负责人列表
export function queryChargeListtApi(data) {
    return request({
        url: '/sys/user/chargeList',
        method: 'post',
        data
    })
}